import React from 'react';
import styles from './winterMaintenceMapWrapper.module.scss';
import L from 'leaflet';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import { withMapControl } from '../../../shared/containers/containerMapControl';
import TopLefttMapControl from '../../LayerMapCotrol/TopLeftMapControl';
import { withAppState } from '../../../shared/containers/containerAppState';
import regionMinsk from './JsonContents/regionMinsk.json';
import WinterMaintenceTimeRangeForm from './WinterMaintenceTimeRangeForm';
import { withWinterMaintence } from '../../../shared/containers/containerWinterMaintence';
import WinterMaintenceSmothFactorRouteSlider from './WinterMaintenceSmothFactorRouteSlider';
import WinterMaintenceCompaniesInfo from './WinterMaintenceCompaniesInfo';
import WinterMaintenceParentCompanyLayer from './WinterMaintenceParentCompanyLayer';
import WinterMaintenceRoutesPoupupCircle from './WinterMaintenceRoutesPoupupCircle';
import WinterMaintenceRoutesMapPoup from './WinterMaintenceRoutesMapPoup';
import DownloadReportsModal from '../../sections/reports/downloadReportsModal';
import WinterMaintenceGeozoneSearch from './WinterMaintenceGeozoneSearch';
import WinterMaintenceCompaniesPeriodInfo from './WinterMaintenceCompaniesPeriodInfo';

const svgRender = L.svg({
  tolerance: 5,
  padding: 1,
});

const WinterMaintenceMapWrapper = (props) => {
  const {
    mapBaseLayer,
    zoom,
    mapCenter,
    isSideBarOpen,
    openCompaniesInfoState,
    findUnitPosition,
    winterAreas,
    winterAreasFilter,
    winterPoupup,
  } = props;

  if (openCompaniesInfoState === 1) {
    return <WinterMaintenceCompaniesInfo />;
  }

  if (openCompaniesInfoState === 2) {
    return <WinterMaintenceCompaniesPeriodInfo />;
  }

  const getFilterArea = (area) => {
    return winterAreasFilter.filter((x) => {
      return x.winterAreaId === area.id;
    })[0];
  };

  const center = findUnitPosition ?? mapCenter;
  const mapZoom = findUnitPosition === null ? zoom : 18;

  const onClosePoupup = (e) => {
    const { onSetWinterPoupup } = props;

    onSetWinterPoupup({ dataPoupup: null, positionPoupup: null });
  };

  return (
    <div className={styles.controlWinterMaintenceMapContainer}>
      <MapContainer
        style={{ height: '100%' }}
        key={`${mapBaseLayer.name} ${center.lat} ${center.lng} ${isSideBarOpen}`}
        crs={mapBaseLayer.crs}
        center={center}
        zoom={mapZoom}
        maxZoom={mapBaseLayer.maxZoom}
        minZoom={3}
        zoomControl={true}
        attributionControl={false}
        doubleClickZoom={false}
        scrollWheelZoom={true}
        dragging={true}
        animate={true}
        renderer={svgRender}
        className={styles.mapMainWrapper}
      >
        <GeoJSON
          data={regionMinsk}
          style={{
            color: 'red',
            fill: false,
            opacity: 1,
            weight: 1,
          }}
        />

        {winterAreas.map((area) => {
          const filterArea = getFilterArea(area);

          if (filterArea === undefined) {
            return null;
          }

          return area.parentCompanies.map((parentCompany) => {
            return (
              <WinterMaintenceParentCompanyLayer
                key={parentCompany.id}
                filterArea={filterArea}
                parentCompany={parentCompany}
                area={area}
              />
            );
          });
        })}

        <WinterMaintenceRoutesMapPoup
          dataPoupup={winterPoupup.dataPoupup}
          position={winterPoupup.positionPoupup}
          onClose={onClosePoupup}
        />

        <WinterMaintenceRoutesPoupupCircle
          dataPoupup={winterPoupup.dataPoupup}
        />

        <TileLayer
          url={'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'}
          updateWhenIdle={true}
          maxZoom={mapBaseLayer.maxZoom}
        />

        <WinterMaintenceGeozoneSearch />
      </MapContainer>

      <TopLefttMapControl left={'50px'}>
        <WinterMaintenceTimeRangeForm />
      </TopLefttMapControl>

      <TopLefttMapControl left={'55px'} top={'80px'}>
        <WinterMaintenceSmothFactorRouteSlider />
      </TopLefttMapControl>

      <DownloadReportsModal />
    </div>
  );
};

export default withAppState(
  withMapControl(withWinterMaintence(React.memo(WinterMaintenceMapWrapper))),
);
